import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Heart } from '@/lib/icons';
import { useFavorites } from '@/hooks/useFavorites';
import { FavoritesModal } from '@/components/FavoritesModal';
import { useBranding } from '@/contexts/BrandingContext';

export const FavoritesButton: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { favoritesCount, loading } = useFavorites();
  const { branding } = useBranding();

  if (loading) {
    return null;
  }

  const primaryColor = branding?.primary_color || '#0EA5E9';

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setModalOpen(true)}
        className="relative hover:text-red-500 transition-colors"
      >
        <Heart className="h-5 w-5" />
        {favoritesCount > 0 && (
          <span 
            className="absolute -top-1 -right-1 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium"
            style={{ backgroundColor: primaryColor }}
          >
            {favoritesCount > 99 ? '99+' : favoritesCount}
          </span>
        )}
      </Button>

      <FavoritesModal
        open={modalOpen}
        onOpenChange={setModalOpen}
      />
    </>
  );
};
